import type { RouteObject } from "react-router";

/** Company documents that consents and the footer link to (public). */
export const legalRoutes: RouteObject[] = [
  {
    path: "legal",
    lazy: async () => ({ Component: (await import("./ui/LegalPage")).LegalIndexPage }),
  },
  {
    path: "legal/:doc",
    lazy: async () => ({ Component: (await import("./ui/LegalPage")).LegalDocumentPage }),
  },
];
